import React from "react";
import { db } from "../firebase";
import { deleteDoc, doc } from "firebase/firestore";
import {
  FormGroup,
  LabelTitle,
  InputDelete,
} from "../pages/student/studentAyarlar";
import { getAuth, deleteUser } from "firebase/auth";

function DeleteAccount() {
  const DeleteAccount2 = async () => {
    try {
      const auth = getAuth();
      const user = auth.currentUser;

      if (!user) {
        console.error("Kullanıcı oturumu geçersiz veya bulunamadı.");
        return;
      }

      // Önce Firestore'daki belgeyi sil
      const userDocRef = doc(db, "users", user.uid);
      await deleteDoc(userDocRef);

      // Daha sonra Authentication'dan kullanıcıyı sil
      await deleteUser(user);

      console.log("Kullanıcı ve Firestore belgesi silindi.");
    } catch (error) {
      console.error("Hesap silme hatası:", error);
    }
  };

  return (
    <FormGroup>
      <LabelTitle>Hesabı Sil</LabelTitle>
      <InputDelete type="submit" value="Hesabı Sil" onClick={DeleteAccount2} />
    </FormGroup>
  );
}

export default DeleteAccount;
